import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

// Shared LabOS Firebase project. Values are injected at build time from
// frontend/.env.local (created by setup-project.sh). Do not hardcode the
// apiKey here — GitHub's secret scanner will block the push.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// NOTE: no client Firestore/Storage SDK. ALL data + asset access goes through
// the IAM-locked engine via the authenticating proxy; the browser never talks
// to Firestore/Storage directly. This project's Firestore/Storage rules are
// owned centrally (shared Firebase project — other apps live here too), so this
// repo intentionally ships no rules files; not importing the SDKs means the
// public web apiKey is never wired to a bypass path in the first place.
export const functions = getFunctions(app);
